import { render, staticRenderFns } from "./softwareversion.vue?vue&type=template&id=465deb7f&scoped=true&"
import script from "./softwareversion.vue?vue&type=script&lang=js&"
export * from "./softwareversion.vue?vue&type=script&lang=js&"
import style0 from "./softwareversion.vue?vue&type=style&index=0&id=465deb7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465deb7f",
  null
  
)

export default component.exports